// Native Sense handles thumbnails, variants, pricing, history and cart IDs.
// This enhancement adds a second zoom level to the existing accessible modal.
document.addEventListener('click',event=>{
 const image=event.target.closest('.pdp-zoom .product-media-modal__content>img.active');
 if(image) image.classList.toggle('pdp-full-resolution');
});
// Keep the image open for zoom; Sense otherwise closes on every mouse pointerup.
document.addEventListener('pointerup',event=>{
 if(event.target.closest('.pdp-zoom .product-media-modal__content>img.active')) event.stopPropagation();
},true);
document.body.addEventListener('modalClosed',()=>{
 document.querySelectorAll('.pdp-full-resolution').forEach(image=>image.classList.remove('pdp-full-resolution'));
});
